import { ArrowRight, ChatCircleDots, Envelope, FacebookLogo, Phone } from '@phosphor-icons/react';
import { CONTACT, OPEN_CHAT_EVENT } from '../../content/site';
import '../LandingPage.css';

function ContactSection() {
  const openChat = () => window.dispatchEvent(new Event(OPEN_CHAT_EVENT));

  return (
    <section id="contact" className="contact-section section" aria-labelledby="contact-title">
      <div className="section-content">
        <div className="contact-panel reveal">
          <div className="contact-intro">
            <h2 id="contact-title" className="section-title contact-title">
              Tell us what you need built
            </h2>
            <p className="contact-lead">
              A short description is enough to start. It helps to know what the
              application should do, who will use it and any deadline you have
              in mind.
            </p>

            <a href={CONTACT.projectEmailHref} className="btn btn--light contact-cta">
              Start a project
              <ArrowRight size={18} weight="bold" aria-hidden="true" />
            </a>
            <p className="contact-reassurance">
              The first conversation is free and does not commit you to anything.
            </p>
          </div>

          <ul className="contact-info">
            <li>
              <a href={CONTACT.phoneHref} className="contact-link">
                <Phone className="contact-link-icon" size={20} aria-hidden="true" />
                <span className="contact-link-body">
                  <span className="contact-link-label">Call us</span>
                  <span className="contact-link-value">{CONTACT.phoneDisplay}</span>
                </span>
              </a>
            </li>
            <li>
              <a href={CONTACT.emailHref} className="contact-link">
                <Envelope className="contact-link-icon" size={20} aria-hidden="true" />
                <span className="contact-link-body">
                  <span className="contact-link-label">Email us</span>
                  <span className="contact-link-value">{CONTACT.email}</span>
                </span>
              </a>
            </li>
            <li>
              <button type="button" className="contact-link" onClick={openChat}>
                <ChatCircleDots className="contact-link-icon" size={20} aria-hidden="true" />
                <span className="contact-link-body">
                  <span className="contact-link-label">Chat</span>
                  <span className="contact-link-value">Ask a question now</span>
                </span>
              </button>
            </li>
            <li>
              <a
                href={CONTACT.facebookHref}
                className="contact-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FacebookLogo className="contact-link-icon" size={20} aria-hidden="true" />
                <span className="contact-link-body">
                  <span className="contact-link-label">Facebook</span>
                  <span className="contact-link-value">
                    Follow EFSoft
                    <span className="sr-only"> (opens in a new tab)</span>
                  </span>
                </span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}

export default ContactSection;
